import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface RecentHistoryItem {
    idx: string;
    s_kind: string;
    f_company: string;
    f_address: string;
    t_company: string;
    t_address: string;
    s_cnt: number;
}

interface RecentHistoryResponse {
    statusCode: number;
    message: string;
    data: RecentHistoryItem[];
}

export const usePostTmpList = (c_code: string) => {
    const sessionid = useMorningAuthStore(state => state.guestSessionId);

    return useQuery({
        queryKey: ["usePostTmpList", c_code || sessionid],
        queryFn: async () => {
            const requestData = c_code ? { c_code } : { sessionid };
            const client = c_code ? axiosInstance : axios;

            const response = await client.post<RecentHistoryResponse>(enum_api_uri.tmp_list, requestData);

            return response.data.data;
        },
        enabled: !!c_code || !!sessionid,
    });
};
